<template>
  <div ref="whole_page">
    <vs-table
      ref="courseTable"
      stripe
      class="vs-con-loading__container"
      single
      @selected="handleSelectedCourse"
      pagination
      :max-items="itemsPerPage"
      search
      :data="coursesAndModules"
      v-scroll-to="'#tasksTable'"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow">
        <div class="pl-3 pb-3 mr-4 flex items-center justify-between font-medium text-base">
          <h3 class="ml-2">Courses & Modules</h3>
        </div>
        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
            class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span
              class="mr-2"
            >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ coursesAndModules.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : coursesAndModules.length }} of {{ coursesAndModules.length }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=50">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=100">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="courseName">Course</vs-th>
        <vs-th sort-key="moduleName">Module</vs-th>
        <vs-th sort-key="moduleDescription">Description</vs-th>
        <vs-th sort-key="moduleProgress">Progress</vs-th>
        <vs-th sort-key="moduleProgress">Status</vs-th>
        <vs-th sort-key="statusHistory">History</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="item" :key="indextr" v-for="(item, indextr) in data">
          <vs-td :data="data[indextr].courseName">{{ item.courseName }}</vs-td>

          <vs-td :data="data[indextr].moduleName">{{ item.moduleName }}</vs-td>

          <vs-td :data="data[indextr].moduleDescription">{{ item.moduleDescription }}</vs-td>

          <vs-td>

            <div style="text-align: center;">
              <vs-progress
                :percent="Number(item.moduleProgress)"
                :color="getProgressColor(Number(item.moduleProgress))"
                :height="12"
                class="shadow-md"
              />
              <small><span>{{item.moduleProgress.toFixed(2) + '%'}}</span></small>
            </div>
          </vs-td>

          <vs-td>
            <div v-if="item.studentModuleStatusId == 9 || item.studentModuleStatusId == 2">
              <div v-if="item.moduleProgress != 100" style="text-align: center;">
                
              </div>
              <div v-else-if="item.lastTaskCompleted"> 
                <vs-chip color="success">Completed</vs-chip>
              </div>
              <div v-else>
                <vs-chip color="success">{{ item.studentModuleStatus }}</vs-chip>
              </div>
            </div>
            <div v-else-if="item.studentModuleStatusId == 10">
              <vs-chip color="success">Assessed</vs-chip>
            </div>
            <div v-else-if="item.lastTaskCompleted">
              <vs-chip color="success">Completed</vs-chip>
            </div>
            <div v-else-if="item.studentModuleStatusId != 9 && item.studentModuleStatusId != null">
              <vs-chip color="success">{{ item.studentModuleStatus }}</vs-chip>
            </div>
            <div v-else>
              <vs-chip color="success">No Status</vs-chip>
            </div>
          </vs-td>

          <vs-td id="statushistorycolumn">
            <vs-button color="success" id="historyButton" type="filled" icon-pack="feather" icon="icon-clock" @click.stop="StatusHistoryShow(item.moduleId)"></vs-button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <vs-divider v-show="showTasks" />
    <vs-table
      v-show="showTasks"
      id="tasksTable"
      ref="tasksTable"
      class="vs-con-loading__container"
      stripe
      single
      pagination
      max-items="10"
      search
      :data="tasks"
      @selected="handleSelectedTask"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow">
        <div class="pl-3 pb-3 mr-4 flex items-center justify-between font-medium text-base">
          <h3 class="ml-2">Completed Tasks</h3>
        </div>
        <div class="mb-4">
          <vs-checkbox v-model="showOnlyAssessed" color="success">Show Only Assessed</vs-checkbox>
        </div>
        <div class="p-3 mb-4 ml-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-success border border-solid border-success" @click="loadTasks">
          <feather-icon icon="RefreshCcwIcon" svgClasses="h-4 w-4" />
          <span class="ml-2 text-base text-success">Refresh</span>
        </div>
      </div>
      <template slot="thead">
        <vs-th sort-key="taskName">Name</vs-th>
        <vs-th sort-key="taskType">Type</vs-th>
        <vs-th sort-key="completedDate">Date Completed</vs-th>
        <vs-th sort-key="statusName">Status</vs-th>
        <vs-th v-if="hasQuiz" >Do Quiz Again</vs-th>
        <vs-th v-if="!hasQuiz"></vs-th>
        <vs-th v-if="hasBrokenUpload">Do Upload Again</vs-th>
        <vs-th v-if="!hasBrokenUpload"></vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="task" :key="indextr" v-for="(task, indextr) in data">
          <vs-td :data="data[indextr].taskName">{{ task.taskName }}</vs-td>

          <vs-td :data="data[indextr].taskType">{{ task.taskType }}</vs-td>

          <vs-td
            :data="data[indextr].completedDate"
            
          >{{ task.completedDate.replace("T", " ").split('.')[0] }}</vs-td>

          <vs-td :data="data[indextr].statusName">
            <vs-chip v-show="statussesToShow.includes(task.statusId)" :color="getStatusColor(task.statusId)">{{ setStatusName(task.statusName) }}</vs-chip>
          </vs-td>

          <vs-td >
            <vs-button v-if="task.taskTypeId == 3 || task.taskTypeId == 9 || task.taskTypeId == 14" color="success" type="flat" icon-pack="feather" icon="icon-eye" @click.stop.prevent="getQuizTask(task.taskId, task.taskTypeId)"></vs-button>
          </vs-td>

          <vs-td >
            <vs-button v-if="task.taskTypeId == 6 && task.uploadBroken"  color="success" type="flat" icon-pack="feather" icon="icon-repeat" @click.stop.prevent="getUploadTask(task.taskId)"></vs-button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <vs-popup id="quizViewPopup" title="" :active.sync="quizViewIsActive" @close="handlePopupClose">
      <quiz-view :isCardActive="quizViewIsActive" 
                 :quizProp="quiz" 
                 @closePopup="closePopup" 
                 @refreshTasks="loadTasks" 
                 :popupXBtnClicked="popupXBtnClicked" 
                 @postEndLog="postEndLog" 
                 :taskTypeId="taskTypeId" 
                 :timeCapture="timeCapture"
                 />
    </vs-popup>

    <vs-popup id="quizViewPopup" title="" :active.sync="iSpringQuizViewIsActive" @close="handlePopupCloseISpring">
      <i-spring-quiz-view :isCardActive="iSpringQuizViewIsActive" :quizProp="ispringQuiz" @closePopup="closePopup" @refreshTasks="loadTasks" :popupXBtnClickedISpring="popupXBtnClickedISpring" @postEndLogISpring="postEndLogISpring" />
    </vs-popup>

    <vs-popup id="statusHistory" title="Status History" :active.sync="statusHistoryIsActive">     
      <vs-table
                  ref="statusHistoryTable"
                  stripe
                  class="vs-con-loading__container"
                  single
                  max-items="5"
                  pagination
                  :data="selectedStatusHistory"
                  search>
          <template slot="thead">
            <vs-th sort-key="moduleName">Module Name</vs-th>
            <vs-th sort-key="fromStatus">From Status</vs-th>
            <vs-th sort-key="toStatus">To Status</vs-th>
            <vs-th sort-key="date">Date</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="selectedStatusHistoryData" :key="indextr" v-for="(selectedStatusHistoryData, indextr) in data">

              <vs-td :data="data[indextr].moduleName">{{ selectedStatusHistoryData.moduleName }}</vs-td>

              <vs-td :data="data[indextr].fromStatus">{{ selectedStatusHistoryData.fromStatus }}</vs-td>

              <vs-td :data="data[indextr].toStatus">{{ selectedStatusHistoryData.toStatus }}</vs-td>

              <vs-td :data="data[indextr].date">{{ selectedStatusHistoryData.date.replace("T", " ").split('.')[0] }}</vs-td>

            </vs-tr>
          </template>
        </vs-table>
    </vs-popup>

  </div>
</template>

<script>
import quizView from './QuizView.vue';
import iSpringQuizView from './iSpringQuizView.vue';
export default {
  components: {
    quizView,
    iSpringQuizView
  },
  data() {
    return {
      quizViewIsActive: false,
      quiz: {},
      itemsPerPage: 6,
      isMounted: false,
      loadingColor: "#fff",
      coursesAndModules: [],
      tasks: [],
      statussesToShow: [1, 2, 3, 4, 5, 6, 11,12,25],
      showTasks: false,
      showOnlyAssessed: false,
      moduleId: 0,
      popupXBtnClicked: false,
      popupXBtnClickedISpring: false,
      iSpringQuizViewIsActive: false,
      ispringQuiz: {},
      taskTypeId: 0,
      statusHistoryIsActive: false,
      selectedStatusHistory: {},
      selectedStatusHistoryData: {},
      captureTimeForAssessments: false,
      timeCapture: {
        captureTimeForAssessments: false,
        formativeHoursRequired: null,
        summativeHoursRequired: null,
        sliderMinFormatives: 0,
        sliderMaxFormatives: 0,
        sliderMinSummatives: 0,
        sliderMaxSummatives: 0,
        taskClassificationTypeId: 0,
      },
      hasQuiz:false,
      hasBrokenUpload:false,
      uploadTaskData:{}
    };
  },
  watch: {
    showOnlyAssessed: function() {
      this.$refs.tasksTable.currentx = 1;
      this.loadTasks();
    }
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.courseTable.currentx;
      }
      return 0;
    }
  },
  methods: {
    StatusHistoryShow(moduleId){
      var self = this;

      self.showLoadingOnElement("whole_page", 1, "corners");

      var onSuccess = function(response) {
        self.selectedStatusHistory = response.data;

        self.statusHistoryIsActive = true;
        
      };
      var onFinally = function() {
        self.$vs.loading.close(self.$refs.whole_page.$el);
      };

      self.$ajaxGet(self, `Student/StatusHistoryForStudentModule?moduleId=${moduleId}`, onSuccess, onFinally);
    },
    postEndLog(payload) {
      var self = this;
      
      self.$ajaxPost(self, "QuizTask/EndLogEntryByClosingPopup", payload);
    },
    postEndLogISpring(payload) {
      var self = this;
      var onSuccess = function (response) {

      };
      self.$ajaxPost(self, "ISpringQuizTask/EndLogEntry", payload, onSuccess);
    },
    handlePopupClose() {
      this.initTimeCaptureValues();
      this.popupXBtnClicked = true;
      this.$store.dispatch("updateTheme", "dark");
    },
    handlePopupCloseISpring() {
      this.initTimeCaptureValues();
      this.popupXBtnClickedISpring = true;
    },
    closePopup() {
      this.initTimeCaptureValues();
      this.quizViewIsActive = false;
      this.iSpringQuizViewIsActive = false;
    },
    initTimeCaptureValues(){
      this.timeCapture.captureTimeForAssessments = false;
      this.timeCapture.formativeHoursRequired = null;
      this.timeCapture.sliderMaxFormatives = 0;
      this.timeCapture.sliderMaxSummatives = 0;
      this.timeCapture.sliderMinFormatives = 0;
      this.timeCapture.sliderMinSummatives = 0;
      this.timeCapture.summativeHoursRequired = null;
      this.timeCapture.taskClassificationTypeId = 0;
    },
    loadCourseInfo() {
      const self = this;
      self.showLoadingOnElement("courseTable", 1, "corners");

      var onSuccess = function(response) {
        self.coursesAndModules = response.data;
      };
      var onFinally = function() {
        self.$vs.loading.close(self.$refs.courseTable.$el);
      };

      self.$ajaxGet(self, "Student/ListCourseInfo", onSuccess, onFinally);
    },
    handleSelectedCourse(courseModule) {
      var self = this;
      self.tasks = [];
      self.showTasks = true;
      self.moduleId = courseModule.moduleId;
      self.captureTimeForAssessments = courseModule.captureTimeForAssessments;
      self.loadTasks();
    },
    loadTasks() {
      var self = this;
      self.showLoadingOnElement("tasksTable", 1, "corners");

      var onSuccess = function (response) {
        self.tasks = response.data;
        self.brokenTaskExists(self.tasks);
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.tasksTable.$el);
      };

      self.$ajaxGet(
        self,
        "Student/ListStudentTasks?moduleId=" + self.moduleId + "&showOnlyAssessed=" + self.showOnlyAssessed,
        onSuccess,
        onFinally
      );
    },
    handleSelectedTask(task) {
      if(task.statusId == 2 || task.statusId == 3 || task.statusId == 7 || task.statusId == 11 || task.statusId == 12 || task.statusId == 14 || task.statusId == 25){
        let routeData = this.$router.resolve({ name: 'ViewAssessment', query: { TaskLogId: task.logId } });
        window.open(routeData.href, '_blank');
      }
      else{
        this.openAlert(task.statusId);
        return;
      }
    },
    getProgressColor(num) {
      if (num > 99) return "success";
      if (num <= 99) return "warning";
    },
    getStatusColor(statusId) {
      var self = this;
      if(statusId == 1)
        return 'primary';
      else if(statusId == 2 || statusId == 3 || statusId == 6)
        return 'success';
      else if(statusId == 4 || statusId == 11 || statusId == 12)
        return 'warning';
      else if(statusId == 5)
        return 'danger';
      else if(statusId == 25)
        return 'primary';
      return 'primary';
    },
    setStatusName(statusName) {
      if(statusName == 'Completed')
        return 'Waiting for Assessment';
      else if(statusName == 'Query')
        return 'Queried';
      else if(statusName == 'Moderated')
        return 'Moderated';
      else if(statusName == 'ReadyForStudentReview' || statusName == 'SurveyReadyForStudentReview'){
        return 'Waiting for Student'
      }
      else if(statusName == 'RemedialsPassedDue')
        return 'Remedials Passed Due';
      else
        return statusName;
    },
    openAlert(status){
      if(status == 1) {
        this.$vs.dialog({
          color: 'warning',
          title: 'Information',
          text: 'Sorry, this task has not been assessed yet.',
          acceptText: 'OK'
        })
      }
      else if(status == 5) {
        this.$vs.dialog({
          color: 'danger',
          title: 'Information',
          text: 'You have already queried this assessment.',
          acceptText: 'OK'
        })
      }
      else if(status == 6) {
        this.$vs.dialog({
          color: 'success',
          title: 'Information',
          text: 'You have already accepted the assessment of this task.',
          acceptText: 'OK'
        })
      }
    },
    getQuizTask(taskId, taskTypeId) {
      var self = this;
      self.taskTypeId = taskTypeId;
      
      if (taskTypeId == 9) {
        self.popupXBtnClicked = false;
        self.quiz = {};
        self.showLoadingOnElement("tasksTable", 1, "corners");

        if(self.captureTimeForAssessments && self.$siteTypeId() != 1)
            self.getTimeCaptureInfo(taskId);

        var onSuccess = function (response) {
          self.quiz = response.data;
          self.quizViewIsActive = true;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.tasksTable.$el);
        };

        self.$ajaxGet(
          self,
          "Student/GetQuizTask?moduleId=" + self.moduleId + "&quizTaskId=" + taskId,
          onSuccess,
          onFinally
        );
      } else if (taskTypeId == 14) {
        self.popupXBtnClicked = false;
        self.quiz = {};

        if(self.captureTimeForAssessments && self.$siteTypeId() != 1)
            self.getTimeCaptureInfo(taskId);

        self.showLoadingOnElement("tasksTable", 1, "corners");

        var onSuccess = function (response) {
          self.quiz = response.data;
          self.quizViewIsActive = true;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.tasksTable.$el);
        };

        self.$ajaxGet(
          self,
          "Student/GetVideoQuizTask?moduleId=" + self.moduleId + "&taskId=" + taskId,
          onSuccess,
          onFinally
        );
      } else {
        self.popupXBtnClickedISpring = false;
        self.ispringQuiz = {};
        self.showLoadingOnElement("tasksTable", 1, "corners");

        var onSuccess = function (response) {
          self.ispringQuiz = response.data;
          self.iSpringQuizViewIsActive = true;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.tasksTable.$el);
        };

        self.$ajaxGet(
          self,
          "Student/GetiSpringQuizTask?moduleId=" + self.moduleId + "&taskId=" + taskId,
          onSuccess,
          onFinally
        );
      }
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    getTimeCaptureInfo(taskId){
      var self = this;

      var onSuccess = function (response) {
        self.getTimeCaptureDetail(response.data, taskId)
      };

      self.$ajaxGet(self, "course/getstory/" + self.moduleId, onSuccess);
    },
    scrollToNavbar() {
      var scrollOptions = {
        easing: "ease-in",
        offset: -500,
        force: true,
        cancelable: true,
        x: false,
        y: true
      };
      var cancelScroll = this.$scrollTo(
        document.getElementById("navbarGlobal"),
        500,
        scrollOptions
      );
    },
    scrollToFooter() {
      var scrollOptions = {
        easing: "ease-in",
        offset: -480,
        force: true,
        cancelable: true,
        x: false,
        y: true
      };
      var cancelScroll = this.$scrollTo(
        document.getElementById("footerGlobal"),
        100,
        scrollOptions
      );
    },
    getTimeCaptureDetail(story, taskId){
      var self = this;

      self.timeCapture.captureTimeForAssessments = story.captureTimeForAssessments;
      self.timeCapture.formativeHoursRequired = story.formativeHoursRequired;
      self.timeCapture.summativeHoursRequired = story.summativeHoursRequired;
      self.timeCapture.taskClassificationTypeId = story.tasks.filter(x => x.Id == taskId).taskClassificationTypeId;

      if(!self.timeCapture.taskClassificationTypeId){
        self.getTaskClassificationId(story, taskId);
      }else{
        self.getMinMaxForTimeCapture(story);
      }
    },
    getTaskClassificationId(story, taskId){
      var self = this;

      var onSuccess = function (response) {
        self.timeCapture.taskClassificationTypeId = response.data;
        self.getMinMaxForTimeCapture(story)
      };

      self.$ajaxGet(self, "student/getTaskClassificationId?taskId=" + taskId, onSuccess);
    },
    getMinMaxForTimeCapture(story){
      var self = this;

      var formativesCount = story.tasks.filter(x => x.taskClassificationTypeId == 1).length;
      var summativesCount = story.tasks.filter(x => x.taskClassificationTypeId == 2).length;

      self.timeCapture.sliderMinFormatives = Math.ceil(self.timeCapture.formativeHoursRequired/formativesCount);
      self.timeCapture.sliderMinSummatives = Math.ceil(self.timeCapture.summativeHoursRequired/summativesCount);

      self.timeCapture.sliderMaxFormatives = Math.ceil(self.timeCapture.sliderMinFormatives + (self.timeCapture.sliderMinFormatives * 50/100));
      self.timeCapture.sliderMaxSummatives = Math.ceil(self.timeCapture.sliderMinSummatives + (self.timeCapture.sliderMinSummatives * 50/100));
    },
    getUploadTask(taskId){
      var self = this;
      self.showLoadingOnElement("whole_page",1,"corners");

      var onSuccess = response =>{
        self.uploadTaskData = response.data;
        self.$router.push({ name: 'StoryViewer', params: { mode: "story", taskDisplayId: self.uploadTaskData.taskDisplayId, moduleId: self.uploadTaskData.moduleId, isStudent: "true", coins: self.uploadTaskData.coins , redoTask:true} });            

      }
    
      var onFinally = response =>{
        if(self.$refs.whole_page){
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      }
    
      self.$ajaxGet(self, `uploadtask/redoTask/${taskId}` , onSuccess, onFinally);
    },
    brokenTaskExists(data){
      var self = this;
      if(data){
        data.forEach(element => {
          if(element.uploadBroken){
            self.hasBrokenUpload = true;
          }
          if(element.taskTypeId == 3 || element.taskTypeId == 9 || element.taskTypeId == 14){
            self.hasQuiz = true;
          }
        });
      }
    }
  },
  mounted() {
    var self = this;
    self.loadCourseInfo();
    if(self.$route.params.CourseProgress){
      this.$refs.courseTable.searchx = self.$route.params.CourseProgress ;
    }
    self.isMounted = true;
  }
};
</script>

<style lang="scss">

#top-right-close {
  right: 0;
  position: absolute;
  top: 0;
  margin-right: 3px;
  margin-top: 3px;
}

#milestones-row {
  align-items: flex-end;
}

#delete-column {
  text-align: -webkit-center;
  text-align: -moz-center;
}

.numberinput {
  background: #ffffff;
  float: left;
}

#optionText_TextArea {
  width: 50%;
}

#statusHistory div.vs-popup {
  width: 1000px;

  .vs-popup--content {
    max-height: none;
  }
}

#historyButton{
  border-radius: 40px 40px 40px 40px
}

#statushistorycolumn{
  width: 80px !important;
}

#data-list-thumb-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;
        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;
          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;
      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }

          &.img-container {
            span {
              display: flex;
              justify-content: center;
            }

            .product-img {
              height: 110px;
            }
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;
        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}

.hoursUsed {
  display:flex ;
  justify-content: center ;
  justify-items: center;
  flex-direction: column;
  text-align: center;
  align-items: center;
  width: 70%;
  margin: 0 auto;
}

@media screen and (max-width: 900px) {  
  .hoursUsed{
    width: 90%;
  }
}

@media screen and (max-width: 550px) {
  .vue-slider-mark-label{
    font-size: 8px;
  }
}

</style>
